import { render, staticRenderFns } from "./BaseIconBtn.vue?vue&type=template&id=2941a9a6&"
import script from "./BaseIconBtn.vue?vue&type=script&lang=js&"
export * from "./BaseIconBtn.vue?vue&type=script&lang=js&"
import style0 from "./BaseIconBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports